import script from "./Voucher.vue?vue&type=script&setup=true&lang=ts"
export * from "./Voucher.vue?vue&type=script&setup=true&lang=ts"

import "./Voucher.vue?vue&type=style&index=0&id=bb1d2024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb1d2024"]])

export default __exports__